import React, {useState, useEffect, useContext} from "react";
import getJson from '../../js/utils/async/getJson';
import CredentialsContext from "../contexts/CredentialsContext";

/*
  Компонент с асинхронной загрузкой данных
  Параметры:
    path - путь для загрузки данных
    render - функция для рендера компонента после загрузки данных. Ей передаются загруженные данные.
*/
export default function AsyncJsonLoader(props){
  const path = props.path;
  const render = props.render;

  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState();
  const [error, setError] = useState();
  const {credentials} = useContext(CredentialsContext);

  useEffect(() => {
    console.log(path);
    getJson(path, credentials.token)(
      (data)=>{
        setData(data);
        setIsLoaded(true); 
      }, 
      (error) => {
        setError(error);
        setIsLoaded(true);
      } 
    )
  }, [props.flag, path]);

  console.log(data);

  if (isLoaded) {
    if (error) {
      return <div>Ошибка: {error}</div>
    } else return render(data)
  } else 
    return <div>Загрузка...</div>
}